import { createSlice } from '@reduxjs/toolkit'

export const storiesSlice = createSlice({
  name: 'stories',
  initialState: {
    "loading": false,
    "tempBanner": false,
    "comics": {
      "hoh": [],
      "aptgg": []
    }
  },
  reducers: {
    loading: (state) => {
      state.loading = true;
    },
    error: (state) => {
      state.loading = false;
    },
    success: (state, action) => {
      state.loading = false;
      state.tempBanner = action.payload["temp_banner"];
      ["hoh", "aptgg"].forEach( story => {
        const comics = action.payload[story];
        if (comics) {
          state.comics[story] = comics.map( (comic) => ({
            "chars": comic.chars || [],
            "title": comic.title || ""
          }));
        }
      });
    }
  }
});

export const actions = storiesSlice.actions;

export default storiesSlice.reducer;